import React from 'react';
import { usePageMeta } from './shared';

const Terms: React.FC = () => {
  usePageMeta('Terms of Service');
  return (
    <>
      <section className="page-head">
        <div className="container">
          <h1>Terms of Service</h1>
          <p>The terms that govern your use of Konklave.</p>
        </div>
      </section>
      <section className="page-body">
        <div className="container">
          <div className="prose">
            <p className="updated">Last updated: June 2026</p>

            <p>
              These Terms of Service (“Terms”) govern your access to and use of Konklave’s websites,
              applications, and services (the “Services”). By using the Services, you agree to these
              Terms. If you are using the Services on behalf of an organization, you represent that you
              are authorized to bind that organization.
            </p>

            <h2>Use of the Services</h2>
            <ul>
              <li>You will use the Services only for lawful purposes and in accordance with these Terms.</li>
              <li>You are responsible for your account credentials and for activity that occurs under your account.</li>
              <li>You will not misuse the Services, attempt to disrupt them, or access them without authorization.</li>
            </ul>

            <h2>Organizations &amp; member content</h2>
            <p>
              Organizations using Konklave are responsible for the content they and their members post,
              for configuring access and privacy settings appropriately, and for complying with
              applicable laws and their own governing rules. We act as a service provider to each
              Organization.
            </p>

            <h2>Payments</h2>
            <p>
              Fees, dues, ticketing, and fundraising processed through the Services are handled by
              third-party payment processors and are subject to their terms. Organizations are
              responsible for their own pricing, refunds, and financial obligations to members.
            </p>

            <h2>Intellectual property</h2>
            <p>
              The Services, including software, design, and branding, are owned by Konklave and its
              licensors. Organizations retain ownership of their own content and trademarks. You may not
              copy, modify, or distribute the Services except as permitted.
            </p>

            <h2>Disclaimers &amp; limitation of liability</h2>
            <p>
              The Services are provided “as is” without warranties of any kind. To the maximum extent
              permitted by law, Konklave is not liable for indirect, incidental, or consequential
              damages arising from your use of the Services.
            </p>

            <h2>Changes</h2>
            <p>
              We may update these Terms from time to time. Continued use of the Services after changes
              take effect constitutes acceptance of the updated Terms.
            </p>

            <h2>Contact</h2>
            <p>Questions about these Terms? Email <a href="mailto:hello@konklave.app">hello@konklave.app</a> or use the contact form on this site.</p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Terms;
